import React from "react";
import Modal from "@Front/Components/DesignSystem/Modal";
import { EButtonstyletype, EButtonVariant } from "@Front/Components/DesignSystem/Button";
import { NotaryMissingContactEmailModalBody } from "./NotaryMissingContactEmailModalBody";
import { useNotaryMissingContactEmailGate } from "./useNotaryMissingContactEmailGate";

/**
 * After IdNot login, prompts notaries (including guest notaries) to set a contact email when none is stored.
 */
export function NotaryMissingContactEmailGate(): React.JSX.Element | null {
	const { open, emailInput, setEmailInput, error, saving, handleLater, handleSave, msg } = useNotaryMissingContactEmailGate();

	if (!open) {
		return null;
	}

	return (
		<Modal
			isOpen={open}
			title={msg.notaryMissingContactEmailModalTitle}
			fullwidth
			firstButton={{
				children: msg.notaryMissingContactEmailModalLater,
				variant: EButtonVariant.SECONDARY,
				styletype: EButtonstyletype.TEXT,
				onClick: handleLater,
				disabled: saving,
			}}
			secondButton={{
				children: msg.notaryMissingContactEmailModalSave,
				variant: EButtonVariant.PRIMARY,
				styletype: EButtonstyletype.CONTAINED,
				onClick: () => void handleSave(),
				disabled: saving,
			}}>
			<NotaryMissingContactEmailModalBody
				msg={msg}
				emailInput={emailInput}
				onEmailChange={setEmailInput}
				saving={saving}
				error={error}
			/>
		</Modal>
	);
}
